// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"b30af730","879":"aff73b56"}[chunkId] + ".chunk.js";
};